const initialState = {
    anchor: 'left',
    fazendaIntegracao: [],
    open: false,
    id: '',
    data_cadastro: '',
    usuario_cadastro: '',
    data_exclusao: '',
    usuario_exclusao: '',
    codigo_integracao: '',
    tipo: ''
};

export function fazendaIntegracao(state = initialState, action) {
    switch (action.type) {
        case 'FETECHED_ALL_FAZENDA_INTEGRACAO':
            return {
                ...state,
                fazendaIntegracao: action.fazendaIntegracao
            };
        case 'FAZENDA_INTEGRACAO_DETAIL':
            return {
                ...state,
                id: action.id,
                data_cadastro: action.data_cadastro,
                usuario_cadastro: action.usuario_cadastro,
                data_exclusao: action.data_exclusao,
                usuario_exclusao: action.usuario_exclusao,
                codigo_integracao: action.codigo_integracao,
                tipo: action.tipo
            };
        case "FAZENDA_INTEGRACAO_UPDATED":
            return state;
        case "HANDLE_ON_CHANGE":
            return {
                ...state,
                [action.props]: action.value
            };
        case 'FAZENDA_INTEGRACAO_CLEAR':
            return {
                ...state,
                anchor: 'left',
                fazendaIntegracao: [],
                open: false,
                id: '',
                data_cadastro: '',
                usuario_cadastro: '',
                data_exclusao: '',
                usuario_exclusao: '',
                codigo_integracao: '',
                tipo: ''
            };
        case 'FAZENDA_INTEGRACAO_CODIGO_CLEAR':
            const { fazendaIntegracao, totalRegistros } = state;

            return {
                ...initialState,
                fazendaIntegracao,
                totalRegistros
            };
        default:
            return state
    }
}
